import { render, staticRenderFns } from "./Updates.vue?vue&type=template&id=26fb703d&scoped=true&"
import script from "./Updates.vue?vue&type=script&setup=true&lang=js&"
export * from "./Updates.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fb703d",
  null
  
)

export default component.exports